import React from 'react'
import Dashboard from '../sections/contact/Dashboard'
import Footer from '../layout/footer'
import ContactForm from '../sections/contact/Contact'
import Reviews from '../sections/review/Reviews'
import { Helmet } from 'react-helmet'

const Contact = () => {
  return (
    <div id='page'>
                  <Helmet>
        <title>Vwrap | Contact Us</title>
        <meta name="description" content="Contact us through the Vwrap website by visiting the contact page, filling out your description, and simply waiting for an expert from our team to reach out!" />
      </Helmet>
      <Dashboard />
      <ContactForm />
      <Reviews />
      <Footer />
    </div>
  )
}

export default Contact
